import { getByPath } from '@/utils/widgets';

export const getStatePathPrefill = (
  uiSchema: Record<string, unknown>,
  trace: unknown
): Record<string, unknown> => {
  const prefill: Record<string, unknown> = {};
  for (const [inputName, fieldUiSchema] of Object.entries(uiSchema ?? {})) {
    const statePath =
      fieldUiSchema &&
      typeof fieldUiSchema === 'object' &&
      'statePath' in fieldUiSchema
        ? fieldUiSchema.statePath
        : undefined;
    if (typeof statePath === 'string') {
      const value = getByPath(trace, statePath);
      if (value !== undefined) {
        prefill[inputName] = Array.isArray(value)
          ? value.filter(item => item !== null)
          : value;
      }
    }
  }
  return prefill;
};
